/**
 * Rct Horizontal Menu Layout
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Scrollbars } from 'Components/Scrollbars/Scrollbars';

// Components
import Header from 'Components/Header/Header';
import Footer from 'Components/Footer/Footer';
import HorizontalMenu from 'Components/HorizontalMenu/HorizontalMenu';
import ThemeOptions from 'Components/ThemeOptions/ThemeOptions';

import './custom.css';

const RctHorizontalLayout = ({ children }) => {
   const location = useLocation();
   const pathname = location.pathname;

   const renderPage = () => {
      if (
         pathname === `/app/chat` ||
         pathname.startsWith(`/app/mail`) ||
         pathname === `/app/todo`
      ) {
         return <div className="rct-page-content p-0">{children}</div>;
      }

      return (
         <Scrollbars
            className="rct-scroll"
            autoHide
            autoHideDuration={100}
            style={{ height: 'calc(100vh - 100px)' }}
         >
            <div className="rct-page-content">
               {children}
               <Footer />
            </div>
         </Scrollbars>
      );
   };

   return (
      <div className="app-horizontal collapsed-sidebar">
         <div className="app-container">
            <div className="rct-page-wrapper">
               <div className="rct-app-content">
                  <div className="app-header">
                     <Header horizontalMenu />
                  </div>
                  <div className="rct-page">
                     <HorizontalMenu />
                     {renderPage()}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default RctHorizontalLayout;
